import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import Home from "@/pages/Home";
import Bikes from "@/pages/Bikes";
import SelfGuided from "@/pages/SelfGuided";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Book from "@/pages/Book";
import BookingSuccess from "@/pages/BookingSuccess";

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

const NotFound = () => (
  <div className="bg-[#F5F5F0] min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
    <p className="overline text-[#001A4D] mb-4">404</p>
    <h1 className="font-serif text-5xl md:text-6xl text-[#0A0A0A]">Page not found</h1>
    <p className="text-[#0A0A0A]/60 mt-4 max-w-md">That page has ridden off somewhere. Let's get you back on track.</p>
    <Link to="/" className="mt-8" data-testid="notfound-home-btn">
      <Button className="rounded-full bg-[#001A4D] hover:bg-[#00287A] text-white h-12 px-8">Back home</Button>
    </Link>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors offset={80} />
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/bikes" element={<PublicLayout><Bikes /></PublicLayout>} />
          <Route path="/self-guided" element={<PublicLayout><SelfGuided /></PublicLayout>} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/book" element={<PublicLayout><Book /></PublicLayout>} />
          <Route path="/privacy" element={<PublicLayout><Privacy /></PublicLayout>} />
          <Route path="/booking/success" element={<PublicLayout><BookingSuccess /></PublicLayout>} />
          <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
